import { IDataTypeAutoComplete } from "../../_common/interface/autocomplete/iDataTypeAutoComplete";
import { dropdownService } from "../../_services/dropdown.service";
import Standard2AutoComplete from "./standard2.autocomplete";

export const DataTypeAutoComplete = (params: IDataTypeAutoComplete) => {

    return (

        <Standard2AutoComplete
            {...params}
            itemsLoader={() => dropdownService.fetchData(params.dataType)}
            parentId={+(params.parentId || 0)}
        />
    );
}